import React from 'react';
import PropTypes from 'prop-types';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from 'mdi-react/DeleteIcon';
import PublishIcon from 'mdi-react/PublishIcon';
import EditIcon from 'mdi-react/EditIcon';
import ScheduleIcon from 'mdi-react/ScheduleIcon';

const DraftsToolbar = ({ numSelected, handleDeleteSelected, handlePublishSelected, handleEditSelected, handleScheduleSelected, onRequestSort }) => (
  <div className="material-table__toolbar-wrap">
    <Toolbar className="material-table__toolbar">
      <div>
        {numSelected > 0 && (
          <h5 className="material-table__toolbar-selected">{numSelected} <span>selected</span></h5>
        )}
      </div>
      <div>
        {numSelected > 0 ? (
          <>
            <IconButton
              onClick={handleDeleteSelected}
              className="material-table__toolbar-button"
            >
              <DeleteIcon />
            </IconButton>
            {numSelected === 1 ? (
              <>
                <IconButton
                  onClick={handlePublishSelected}
                  className="material-table__toolbar-button"
                >
                  <PublishIcon />
                </IconButton>
                <IconButton
                  onClick={handleEditSelected}
                  className="material-table__toolbar-button"
                >
                  <EditIcon />
                </IconButton>
                <IconButton
                  onClick={handleScheduleSelected}
                  className="material-table__toolbar-button"
                >
                  <ScheduleIcon />
                </IconButton></>) : null}
          </>
        ) : null}
      </div>
    </Toolbar>
  </div>
);

DraftsToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
  // handleDeleteSelected: PropTypes.func.isRequired,
  onRequestSort: PropTypes.func.isRequired,
};

export default DraftsToolbar;
